const portfolioData = [
  {
    title: "Fashion Campaign",
    category: "Brand Communication",
    description:
      "Creating strong visual identities and meaningful brand experiences.",
  },
  {
    title: "Visual Merchandising",
    category: "Retail Experience",
    description:
      "Developing inspiring store concepts focused on customer experience.",
  },
  {
    title: "Styling Project",
    category: "Creative Direction",
    description:
      "Combining styling, trends and storytelling into contemporary fashion concepts.",
  }
];

export default portfolioData;